class MultiATC extends HTMLElement {
  constructor() {
    super();

    this.cta = this.querySelector("button");
    this.cart = document.querySelector("cart-drawer");

    this.atcForm = new FormData();
  }

  addToBag() {
    if (this.cart && !this.cart.loading) {
      const atcConfig = fetchConfig("javascript");
      atcConfig.headers["x-requested-with"] = "XMLHttpRequest";
      delete atcConfig.headers["Content-Type"];

      if (!(this.atcForm instanceof FormData)) {
        this.atcForm = new FormData();
      }
      this.variantIds = this.dataset.variantIds.split(",");
      this.variantIds.forEach((variantId, index) => {
        this.atcForm.append(`items[${index}][id]`, variantId);
        this.atcForm.append(`items[${index}][quantity]`, 1);
      });

      if (this.atcForm.get("sections") && this.atcForm.get("sections_url")) {
        this.atcForm.set(
          "sections",
          this.cart.getSectionsToRender().map((section) => section.id)
        );
        this.atcForm.set("sections_url", window.location.pathname);
      } else {
        this.atcForm.append(
          "sections",
          this.cart.getSectionsToRender().map((section) => section.id)
        );
        this.atcForm.append("sections_url", window.location.pathname);
      }

      this.cart.setActiveElement(document.activeElement);

      atcConfig.body = this.atcForm;

      this.cart.open();
      this.cart.setLoading();

      fetch(routes.cart_add_url, atcConfig)
        .then((response) => response.json())
        .then((response) => {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "vbb-multi-atc",
          });

          this.cart.renderContents(response);

          this.sendAddToCartTrackingEvent();
        })
        .catch((e) => console.error(e))
        .finally(() => {
          if (this.cart && this.cart.classList.contains("is-empty")) {
            this.cart.classList.remove("is-empty");
          }

          this.cart.setNotLoading();
        });
    }
  }

  sendAddToCartTrackingEvent() {
    if (window.Shopify && window.Shopify.analytics) {
      const trackingInfo = JSON.parse(
        this.querySelector("#tracking-data").content.textContent
      );

      const trackingData = {
        event: "add_to_cart",
        ecommerce: {
          currency: trackingInfo.currency,
          items: trackingInfo.items.map((item, index) => ({
            item_id: item.item_id,
            item_name: item.item_name,
            affiliation: "Victoria Beckham Beauty",
            currency: trackingInfo.currency,
            ...(item.discount != null && {
              discount: item.discount,
            }),
            index,
            item_brand: "Victoria Beckham Beauty",
            ...(item.item_variant != null && {
              item_variant: item.item_variant,
            }),
            price: item.price,
            quantity: 1
          })),
        },
      };

      trackingData.ecommerce.value = trackingData.ecommerce.items.reduce(
        (total, item) => {
          return total + item.price;
        },
        0
      );

      window.Shopify.analytics.publish(
        "custom_product_add_to_cart",
        trackingData
      );
    }
  }

  connectedCallback() {
    this.cta.addEventListener("click", () => this.addToBag());
  }

  disconnectedCallback() {
    this.cta.removeEventListener("click", () => this.addToBag());
  }
}

customElements.define("vbb-multi-atc", MultiATC);
